export const GOOGLE_TRACKING_ID_ANALYTICS = "G-BEELXZ1PWX";

export const GOOGLE_TRACKING_ID_ADS = "AW-10931211234";

export const GOOGLE_TAG_MANAGER_ID = "GTM-NRVSBHHT";
